export default function WhyChooseUs() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-white relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full opacity-5">
        <div className="absolute top-20 left-20 w-32 h-32 bg-green-600 rounded-full"></div>
        <div className="absolute bottom-40 right-40 w-24 h-24 bg-green-500 rounded-full"></div>
        <div className="absolute top-1/2 right-20 w-16 h-16 bg-green-400 rounded-full"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Why Choose Gavin Luke Tree & Stump Service?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            With years of experience and a commitment to excellence, we've built our reputation on delivering safe, reliable, and professional tree services that exceed expectations.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative z-10">
              <div className="w-full h-96">
                <img
                  src="https://public.readdy.ai/ai/img_res/ce50d548fbedf8604ab02fe4b0196835.jpg"
                  alt="Stump grinder machine is grinding tree stump in yard"
                  className="w-full h-full object-cover object-top rounded-2xl shadow-2xl"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-full h-full bg-green-600 rounded-2xl -z-10"></div>
            </div>
            <div className="absolute -top-8 -right-8 bg-gray-800 text-white rounded-2xl shadow-xl p-6 z-20">
              <div className="text-2xl font-bold">500+</div>
              <div className="text-sm">Projects Completed</div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center">
                <i className="fas fa-certificate text-2xl text-green-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Experienced Professionals</h3>
                <p className="text-gray-600">
                  Our team consists of experienced professionals and licensed professionals who stay current with industry best practices and safety standards.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center">
                <i className="fas fa-tools text-2xl text-green-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">State-of-the-Art Equipment</h3>
                <p className="text-gray-600">
                  We invest in the latest professional-grade equipment to ensure efficient, safe, and precise tree and stump removal services.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center">
                <i className="fas fa-dollar-sign text-2xl text-green-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Competitive & Transparent Pricing</h3>
                <p className="text-gray-600">
                  No hidden fees or surprise charges. We provide detailed, upfront quotes so you know exactly what to expect.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center">
                <i className="fas fa-broom text-2xl text-green-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Complete Cleanup Service</h3>
                <p className="text-gray-600">
                  We don't just remove trees and stumps - we leave your property cleaner than we found it, handling all debris removal and site restoration.
                </p>
              </div>
            </div>

            <div className="pt-6">
              <button
                onClick={() => scrollToSection('quote')}
                className="inline-flex items-center bg-green-600 text-white hover:bg-green-700 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                Get Your Free Quote Today
                <i className="fas fa-arrow-right ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
